/**
 * useTextToSpeech — thin re-export of @boox/ui-foundation hook.
 * Injects api.post as the ttsFn so the hook stays API-agnostic.
 */

import { api } from '@/lib/api';
import {
  useTextToSpeech as _useTextToSpeech,
  type UseTextToSpeechOpts,
} from '@boox/ui-foundation';

export type { UseTextToSpeechOpts } from '@boox/ui-foundation';

export function useTextToSpeech(opts: Omit<UseTextToSpeechOpts, 'ttsFn'> = {}) {
  return _useTextToSpeech({
    ...opts,
    ttsFn: async (text, lang, context) => {
      return api.post<{ audio?: string; mimeType?: string; text?: string; useBrowserTTS?: boolean }>(
        '/voice/tts',
        {
          text,
          lang,
          role: context?.role,
          surface: context?.surface,
          profile: context?.profile,
          voiceStyle: context?.voiceStyle,
          requireRemoteAudio: context?.requireRemoteAudio,
        },
      );
    },
  });
}
